import { showErrorMessage } from 'actions/messages';
import { workOrdersApi } from 'services/api/work-orders-api';
import {
  TIME_ADD_ENTRY_SUCCESS,
  TIME_ADD_MODAL_SHOW,
  TIME_ID_RATE_TO_EDIT,
  TIME_RATE_CONFIRM_SUCCESS,
  TIME_RATE_SET,
  TIME_REMOVE,
  TIME_SET,
  TIME_TO_EDIT,
  TIME_UPDATE,
} from 'components/admin/work-orders/details/time/store/action-types';
import { tasksApi } from 'services/api/tasks-api';
import { timeApi } from 'services/api/time-api';

export function addTimeEntry(taskId, values) {
  return (dispatch) => {
    return tasksApi.createTimeEntry(taskId, values).then((response) => {
      if (response.ok) {
        dispatch(addTimeEntrySuccess(response.timeEntry));
        dispatch(setShowAddTimeModal(false));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

function addTimeEntrySuccess(timeEntry) {
  return {
    type: TIME_ADD_ENTRY_SUCCESS,
    payload: timeEntry,
  };
}

export function confirmRate(taskId, timeId, newRate) {
  return (dispatch) => {
    return timeApi.updateTimeEntryRate(timeId, newRate).then((response) => {
      if (response.ok) {
        dispatch(confirmRateSuccess(response.timeEntry));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

function confirmRateSuccess(timeEntry) {
  return {
    type: TIME_RATE_CONFIRM_SUCCESS,
    payload: timeEntry,
  };
}

export function deleteTime(timeId) {
  return (dispatch) => {
    return timeApi.deleteTimeEntry(timeId).then((response) => {
      if (response.ok) {
        dispatch(removeTime(timeId));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

export function editTimeEntry(timeId, values) {
  return (dispatch) => {
    return timeApi.editTimeEntry(timeId, values).then((response) => {
      if (response.ok) {
        dispatch(updateTimeEntry(response.timeEntry));
        dispatch(setShowAddTimeModal(false));
        dispatch(setCurrentTimeToEdit(null));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

export function getTime(workOrderId) {
  return (dispatch) => {
    return workOrdersApi.getTime(workOrderId).then((response) => {
      if (response.ok) {
        dispatch(setTime(response.time));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

function removeTime(timeId) {
  return {
    type: TIME_REMOVE,
    payload: timeId,
  };
}

export function setCurrentTimeRateToEdit(timeId, rate = null) {
  return {
    type: TIME_ID_RATE_TO_EDIT,
    payload: { timeId, rate },
  };
}

export function setCurrentTimeToEdit(time) {
  return {
    type: TIME_TO_EDIT,
    payload: time,
  };
}

export function setRate(rate) {
  return {
    type: TIME_RATE_SET,
    payload: rate,
  };
}

export function setShowAddTimeModal(value) {
  return {
    type: TIME_ADD_MODAL_SHOW,
    payload: value,
  };
}

function setTime(time) {
  return {
    type: TIME_SET,
    payload: time,
  };
}

function updateTimeEntry(timeEntry) {
  return {
    type: TIME_UPDATE,
    payload: timeEntry,
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/time/store/actions.js